package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun CounterspellMetadata() {
    SpellMetadata(
        spellIndex = "counterspell",
        castingTime = "1 reaction",
        range = "60 feet",
        components = listOf(SpellComponent.SOMATIC),
        material = null,
        duration = "Instantaneous",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
